import React from "react";
import { io } from "socket.io-client";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const API_ORIGIN = API_BASE_URL.replace(/\/api$/i, "");
const Connectws = () => {
  return io(API_ORIGIN);
};

export default Connectws;
